// extracted by mini-css-extract-plugin
export default {"container":"CustomerCardAndChat_container__f+o6L"};